/** 提现 */
<template>
  <div class="exchange-list-wrap margin-top-20">
    <BasiceLayout
      title="兑换记录"
      class="withdrawal-layout"
      empty-text="loading"
    >
      <el-table
        v-if="exchangeList !== 'NONE'"
        :data="exchangeList"
        style="width: 100%;min-height: 200px"
      >
        <el-table-column
          prop="time"
          label="发起时间"
          align='center'
        >
        </el-table-column>
        <el-table-column
          prop="exchangeJDMoney"
          label="兑换JD卡总额"
          align='center'
        >
          <template slot-scope="scope">
            <div>{{scope.row.exchangeJDMoney}} 元</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="JDCardMoney"
          label="面额"
          align='center'
        >
          <template slot-scope="scope">
            <div>{{scope.row.JDCardMoney}} 元</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="JDCardCount"
          label="张数"
          align='center'
        >
        </el-table-column>
        <el-table-column
          label="兑换状态"
          align='center'
        >
          <template slot-scope="scope">
            <div v-if="scope.row.exchangeStatus == 1">兑换中</div>
            <div
              class="bonus-color bonus-cursor"
              v-if="scope.row.exchangeStatus == 2"
              @click="showJDPassAuth(scope.row.id)"
            >查看卡密</div>
            <div v-if="scope.row.exchangeStatus == 3">兑换失败</div>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="exchangeList === 'NONE'"
        empty-text="暂无兑换记录"
      ></el-table>
    </BasiceLayout>

    <el-dialog
      title="查看卡密"
      :visible.sync="showJDPassAuthDialog"
      width="480px"
      center
    >
      <div class="unbind-dialog-wrap">
        <span class="key verify-key">{{$t('dialog.imageVerify')}}</span>
        <div class="hard-captcha">
          <!-- 谷歌验证 -->
          <vue-recaptcha
            class="captcha-wrap"
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            data-size="normal"
            :sitekey="sitekey"
          />
        </div>
      </div>
      <div class="unbind-dialog-wrap">
        <span class="key mail-key">{{$t('dialog.mailText')}}</span>
        <SendEmailCode
          type="text"
          imageStyle="unbind-style"
          :response="response"
          class="unbind-input password-email"
          v-model="inputEmailCode"
          needImageCode=true
          :email="email"
          @emailCodeTip="emailCodeTip"
        ></SendEmailCode>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          @click="showJDPassAuthDialog = false"
        >{{ $t('cancel') }}</div>
        <div
          class="sure-unbind button"
          type="primary"
          @click="showJDPass"
        >{{ $t('sure') }}</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import VueRecaptcha from "vue-recaptcha";
import { LANG, SITEKEY } from "../../../config/contant.js";
import SendEmailCode from "@/components/SendEmailCode.vue";
import { Message } from "element-ui";

export default {
  name: "AccountLayout",
  components: {
    BasiceLayout,
    VueRecaptcha,
    SendEmailCode
  },
  data() {
    return {
      showJDPassAuthDialog: false,
      response: "",
      sitekey: SITEKEY["LOW"], //ga verify key
      inputEmailCode: "", //输入的邮件码
      dealId: ""
    };
  },
  props: {},
  computed: mapState({
    //  箭头函数可使代码更简练
    exchangeList: state => state.exchange.exchangeList,
    email: state => state.account.email
  }),
  created() {
    this.getExchangeList();
  },
  methods: {
    ...mapActions(["getExchangeList", "getJDOrderPass"]),
    // 查看卡密
    showJDPassAuth(id) {
      this.showJDPassAuthDialog = true;
      this.dealId = id;
    },
    showJDPass() {
      let { inputEmailCode, dealId } = this;

      this.getJDOrderPass({ emailVerifyCode: inputEmailCode, dealId }).then(
        res => {
          if (res.data && res.data.length) {
            let html = "";
            res.data.map((item, index) => {
              html += `<div> 卡密 ${index + 1}：${item.card}`;
            });
            this.$alert(html, "卡密", {
              dangerouslyUseHTMLString: true,
              width: "480px"
            });
          } else {
            Message({
              type: "error",
              message: res.message || "network error"
            });
          }
        }
      );
    },
    onVerify: function(response) {
      this.response = response;
    },
    onExpired: function() {
      Message({
        message: this.$t("captcha.expired"),
        type: "error"
      });
      this.$refs.recaptcha.reset();
    },
    // email错误提示
    emailCodeTip(error) {
      if (error.message) {
        Message({
          type: "error",
          message: error.message
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.exchange-list-wrap .el-message-box {
  width: 800px;
}
</style>

